import {
  mapState,
  mapActions,
} from 'vuex';

export default {

  data() {
    return {
      adminSchemaLoaded: false,
    };
  },

  computed: {
    ...mapState({
      spawnerAdminSchemas: state => state.spawnerAdminSchemas.spawnerAdminSchemas,
    }),
  },

  methods: {
    ...mapActions(['getSpawnerAdminSchema']),

    async loadSpawnerAdminSchema(schema) {
      if (this.debug) { console.log(`${schema} schema requested!`); }
      if (Object.keys(this.spawnerAdminSchemas[schema]).length === 0) {
        try {
          if (this.debug) { console.log(`fetching ${schema} schema...`); }
          await this.getSpawnerAdminSchema({
            params: {
              schema,
            },
          });

          if (this.debug) { console.log(`${schema} fetched!`); }

          this.adminSchemaLoaded = true;
          Bus.$emit('spawner_admin_schema_loaded');
        } catch (error) {
          if (this.debug) { console.log(error); }
        }
      } else if (this.debug) {
        console.log(`${schema} schema already fetched!`);

        this.adminSchemaLoaded = true;
        Bus.$emit('spawner_admin_schema_loaded');
      }
    },
  },

  mounted() {
    Bus.$on('spawner_admin_schema_loaded', () => {
      if (this.debug) { console.log('schemas-loader.spawnerAdminSchemas', this.spawnerAdminSchemas); }
    });

    Bus.$on('refresh_admin_schema', (schema) => {
      this.loadSpawnerAdminSchema(schema);
    });

    Bus.$on('refresh_admin_schemas', () => {
      this.loadSpawnerAdminSchema('forms');
    });
  },

  beforeDestroy() {
    Bus.$off('spawner_admin_schema_loaded');
    Bus.$off('refresh_admin_schema');
    Bus.$off('refresh_admin_schemas');
  },
};
